import { render } from "./MainSettings.vue?vue&type=template&id=19eca3b4"
import script from "./MainSettings.vue?vue&type=script&lang=js"
export * from "./MainSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__